export const getThemeFromCourse = course => course && course.mainTheme

export const getCourseId = course => course && course.id

export const getCourseTitle = course => course && course.title
